export default "__VITE_ASSET__44c0d82d__"